/**
 * Terms + recovery-email state for the auth gates, straight from the shared
 * `users/{uid}` listener. No callables — a gate decision must not wait on
 * billing (see hooks/userDocStore.ts).
 */
import { useEffect, useState } from 'react';
import { getFirebaseAuth } from '../config/firebase';
import {
  cachedRecovery,
  EMPTY_RECOVERY,
  subscribeUserDoc,
  type RecoveryEmailState,
} from './userDocStore';

export function useUserRecovery(enabled: boolean): {
  recovery: RecoveryEmailState;
  recoveryReady: boolean;
} {
  const uid = enabled ? (getFirebaseAuth().currentUser?.uid ?? null) : null;
  const [state, setState] = useState(() =>
    uid ? cachedRecovery(uid) : { recovery: EMPTY_RECOVERY, ready: false },
  );

  useEffect(() => {
    if (!uid) {
      setState({ recovery: EMPTY_RECOVERY, ready: false });
      return;
    }
    return subscribeUserDoc(uid, (recovery, ready) => setState({ recovery, ready }));
  }, [uid]);

  return { recovery: state.recovery, recoveryReady: state.ready };
}
